<p>{{bioService.getBio()}}</p>
<br/>
<p>looking for a <a title="still working on that one">résumé</a>?</p>